import { Box } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { useSelector } from 'react-redux';
import { selectUserById } from '../../reducers/accountUsersReducer';
import { AvatarPicture } from '../avatar/AvatarPicture';
import { DIMENSION_AVATAR_VERY_SMALL } from '../../constants';
import { getIsUserInactive } from '../../lib/getIsUserActive';

interface ConversationCopyMessageProps {
  userId: string;
}

export const ConversationCopyMessage = ({ userId }: ConversationCopyMessageProps) => {
  const user = useSelector(selectUserById(userId));

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box display="flex" gap={0.5} alignItems="center">
        <Typography variant="body" color={colors.grey[700]}>
          This is a copy of a conversation between Sweep's agent and {user?.name || 'Unknown User'}
        </Typography>
        {user && (
          <AvatarPicture
            avatar={{ emoji: user.emoji, imageUrl: user.imageUrl }}
            dimension={DIMENSION_AVATAR_VERY_SMALL}
            clickable={false}
            isInactive={getIsUserInactive(user.status)}
          />
        )}
      </Box>
    </Box>
  );
};
